// extracted by mini-css-extract-plugin
export default {"page":"Quiz_page__Nkk5p","bg":"Quiz_bg__7F9+c"};